import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31e0406e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact" }
const _hoisted_2 = { class: "information" }
const _hoisted_3 = { href: "/commissions" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "form-name",
  value: "contact"
}, null, -1))
const _hoisted_5 = { class: "inputs" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hidden" }, [
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createTextVNode(" Don’t fill this out if you’re human: "),
    /*#__PURE__*/_createElementVNode("input", { name: "bot-field" })
  ])
], -1))
const _hoisted_7 = { for: "email" }
const _hoisted_8 = { for: "message" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { "data-netlify-recaptcha": "true" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      plural: true,
      title: "contact",
      subtitle: "Let's get in touch!"
    }),
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t("contact-1")) + " ", 1),
      _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$t("Commissions page")), 1),
      _createTextVNode(". " + _toDisplayString(_ctx.$t("contact-2")) + ". ", 1)
    ]),
    _createElementVNode("form", {
      name: "contact",
      method: "post",
      "data-netlify": "true",
      "data-netlify-honeypot": "bot-field",
      "data-netlify-recaptcha": "true",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", {
          class: _normalizeClass(["input-container", { invalid: _ctx.isEmailInvalid, filled: _ctx.formData.email !== '' }])
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "email",
            name: "email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.email) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formData.email]
          ]),
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("Your email")) + ":", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.emailError)), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["input-container", {
            invalid: _ctx.isMessageInvalid,
            filled: _ctx.formData.message !== '',
          }])
        }, [
          _withDirectives(_createElementVNode("textarea", {
            name: "message",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.message) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formData.message]
          ]),
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("Message")) + ":", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.messageError)), 1)
        ], 2)
      ]),
      _hoisted_9,
      _createVNode(_component_CommonButton, {
        "disable-conditions": 
          _ctx.formData.email === '' ||
          _ctx.formData.message === '' ||
          _ctx.isEmailInvalid ||
          _ctx.isMessageInvalid
        ,
        type: "submit",
        onClick: _ctx.handleSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("Send")), 1)
        ]),
        _: 1
      }, 8, ["disable-conditions", "onClick"])
    ], 32)
  ]))
}